module.exports = __webpack_public_path__ + "i18n/en_a8acef468ed08886a31c80edfcb59a27.json";


//////////////////
// WEBPACK FOOTER
// ./app/assets/i18n/en.json
// module id = aY29
// module chunks = 153